import { render, staticRenderFns } from "./CustomersDetails.vue?vue&type=template&id=01848789&"
import script from "./CustomersDetails.vue?vue&type=script&lang=js&"
export * from "./CustomersDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports